var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var FillArrowDown = function FillArrowDown(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M10.65 14.962a2 2 0 0 0 3.11 0l3.968-4.91c1.057-1.307.126-3.257-1.555-3.257H8.237c-1.682 0-2.613 1.95-1.556 3.258l3.968 4.909Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default FillArrowDown;